export default __webpack_public_path__ + "static/8-d1b3f793639d50e8bae85ef6cf4e8669.png";